import { atom, useRecoilState } from 'recoil'

import { API_PARAMS } from '../config/consts'
import { calcDay } from '../utils/date'

export interface LocationDateTimeItem {
  radio: string
  siteId: string | null
  floorId: string | null
  siteGroupId: string | null
  range: string | null
  fromDate: Date | null
  toDate: Date | null
}

const today = new Date()

// toDate: todayをcalcDay(today, -1)に移行。当日をリクエストに含めないようにする。

export const LocationDateTimeAtom = atom<LocationDateTimeItem>({
  key: 'LocationDateTimeAtom',
  default: {
    radio: 'site',
    siteId: API_PARAMS.SELECT_ALL,
    floorId: API_PARAMS.SELECT_ALL,
    siteGroupId: '',
    range: '1',
    fromDate: calcDay(today, -1),
    toDate: calcDay(today, -1),
    // toDate: today,
  },
})

const useLocationDateTimeForm = () => {
  const [form, setForm] = useRecoilState(LocationDateTimeAtom)
  return { form, setForm }
}

export default useLocationDateTimeForm
